import { Injectable } from '@angular/core';
import { LocalStorageSvc } from './localStorage.service';
import { SessionStorageService } from './session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class FolderService {

  public clickedFolderName: string = '';
  public currentFolderKey:string = '';
  public currentFolderName:string = '';
  public currentFolder:any ;
  public parentFolderKey:string = '';
  public parentFolderName:string = '';
  public parentFolder:any;
  public breadCrumbsList:any = [];
  public rootFolderObject:any = [];
  public breadCrumbsListMoveCopy:any = [{objectKey: '1', objectName: 'All Files', folder: null}];
  
  constructor(private localStorageSvc:LocalStorageSvc,private sessionStorageSvc:SessionStorageService) {
    
  }
  // This is to initialise the breadcrumb, clear it and maintain root directory first 
  initialiseBreadCrumbs(folderObjectKey, folderObjectName, folderObject) {
    
    this.rootFolderObject = {
      objectKey: folderObjectKey,
      objectName: folderObjectName,
      folder:folderObject,
      tfKey : folderObject ? folderObject["tfKey"] : null
    };    
    this.breadCrumbsList = [];
    this.breadCrumbsList.push(this.rootFolderObject);
    if(folderObjectKey == "1" && folderObjectName == "Team Folders"){
      //this.localStorageSvc.setBreadCrumbsList(this.breadCrumbsList, true);
      this.sessionStorageSvc.setBreadCrumbsList(this.breadCrumbsList, true);
    }
  }

  // This is to navigate through breadcrumb and take out object key of clicked folder name in list
  openFolderFromBreadCrumb (folderKey) {
    var folderToOpen = this.breadCrumbsList.filter(breadCrumbsList => breadCrumbsList.objectKey === folderKey);
    var tempBreadcrumbArr = this.breadCrumbsList;
    tempBreadcrumbArr.forEach((obj, index) => {
      if (obj.objectKey == folderToOpen[0].objectKey) {
        tempBreadcrumbArr.splice(tempBreadcrumbArr.indexOf(obj) + 1, (tempBreadcrumbArr.length - 1))
      }
    });
    this.currentFolderKey = folderToOpen[0].objectKey;
    this.currentFolderName = folderToOpen[0].objectName;
    this.currentFolder = folderToOpen[0].folder;
    this.breadCrumbsList = tempBreadcrumbArr;
    //this.universalService.selectedFile =  folderToOpen[0].folder;
    return folderToOpen[0].folder;
  }

  // This is to manage breadcrumbs while accessing sub-folders
  manageBreadCrumbs(folderObjectKey, folderObjectName,folderObject, fromViewButton = false) {
    if(fromViewButton){
      this.breadCrumbsList = this.breadCrumbsListMoveCopy;
    }
    else{
      if(this.breadCrumbsListMoveCopy.length > 1){
        this.breadCrumbsListMoveCopy = [{objectKey: '1', objectName: 'All Files', folder: null}];
      }
      this.breadCrumbsList.push({
        "objectKey": folderObjectKey,
        "objectName": folderObjectName,
        "folder":folderObject,
        "tfKey" : folderObject ? folderObject["tfKey"] : null
      });
    }
    this.breadCrumbsList = this.deDupArray(this.breadCrumbsList, 'objectKey')
    this.updateFolderNames();
    //this.localStorageSvc.setBreadCrumbsList(this.breadCrumbsList, true);
    this.sessionStorageSvc.setBreadCrumbsList(this.breadCrumbsList, true);
  }

  updateBreadCrumbList(breadCrumbsList){
    this.breadCrumbsList = breadCrumbsList;
    this.updateFolderNames();
  }

  updateFolderNames(){
    if( this.breadCrumbsList.length > 2 ) {
      this.currentFolderKey = this.breadCrumbsList[this.breadCrumbsList.length-1].objectKey;
      this.currentFolderName = this.breadCrumbsList[this.breadCrumbsList.length-1].objectName;
      this.currentFolder = this.breadCrumbsList[this.breadCrumbsList.length-1].folder;

      this.parentFolderKey = this.breadCrumbsList[this.breadCrumbsList.length-2].objectKey;
      this.parentFolderName = this.breadCrumbsList[this.breadCrumbsList.length-2].objectName;
      this.parentFolder = this.breadCrumbsList[this.breadCrumbsList.length-2].folder;
      
    } else if( this.breadCrumbsList.length > 1 ) {
      this.currentFolderKey = this.breadCrumbsList[this.breadCrumbsList.length-1].objectKey;
      this.currentFolderName = this.breadCrumbsList[this.breadCrumbsList.length-1].objectName;   
      this.currentFolder = this.breadCrumbsList[this.breadCrumbsList.length-1].folder;
   
    } else {
      this.currentFolderKey = '';
      this.currentFolderName = '';
      this.currentFolder = null;

      this.parentFolderKey = '';
      this.parentFolderName = '';
      this.parentFolder = null;
    } 
  }


  // De duplicate the array
  deDupArray(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};    
    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }

}
